module.exports = __webpack_public_path__ + "media/hero-video.a2f05011.mp4";